


import WebCam from "react-webcam"
import React, { useRef, useState, useEffect, Component, createRef } from "react"
import "../../css/Camara.css"
import axios from 'axios';
import equis from "../../assets/eliminar.svg"
import { Spinner } from 'react-bootstrap';
import NotificacionTip from "./NotificacionTip";


class camara extends Component {


    constructor(props) {
        super(props);

        this.state = {
            imgSrc: "",
            showImg: false,
            showerr: false,
            showerrtoken: false,
            activebutton: true,
            isFace: this.props.rostro,
            numidentifica: this.props.identificacion,
            token_nueva_cuenta: sessionStorage.getItem("token_nueva_cuenta")
        }

        this.captureImage = this.captureImage.bind(this);
        this.Volver = this.Volver.bind(this);
        this.Guardar = this.Guardar.bind(this);
        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });

    }
    componentDidMount() {
        this.getStream().then(this.getDevices).then(this.gotDevices)
    }

    /*componentDidUpdate() {
        if (!this.state.showImg && !this.state.showerr) {

            this.getStream().then(this.getDevices).then(this.gotDevices)
        }
    }*/
    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.showImg !== this.state.showImg &&
            !this.state.showImg &&
            !this.state.showerr
        ) {
            this.getStream().then(this.getDevices).then(this.gotDevices)
        }
    }


    getDevices = async () => {
        return await navigator.mediaDevices.enumerateDevices();
    }

    gotDevices(deviceInfos) {
        var videoSelect = document.getElementById('videoSource');
        try {
            window.deviceInfos = deviceInfos; // make available to console
            for (const deviceInfo of deviceInfos) {
                const option = document.createElement('option');
                option.value = deviceInfo.deviceId;
                if (deviceInfo.kind === 'videoinput') {
                    option.text = deviceInfo.label || `Camera ${videoSelect.length + 1}`;
                    videoSelect.appendChild(option);


                }
            }
        } catch (error) {
            //console.log(error);

        }

    }

    getStream() {
        var videoSelect = document.getElementById('videoSource');
        if (window.stream) {
            window.stream.getTracks().forEach(track => {
                track.stop();
            });
        }
        const videoSource = videoSelect.value;
        const constraints = {
            video: { deviceId: videoSource ? { exact: videoSource } : undefined }
        };
        return navigator.mediaDevices.getUserMedia(constraints).
            then(this.gotStream).catch(this.handleError);


    }

    gotStream(stream) {
        try {
            var videoSelect = document.getElementById('videoSource');
            var videoElement = document.getElementById('videoCam')

            window.stream = stream; // make stream available to console
            videoSelect.selectedIndex = [...videoSelect.options].
                findIndex(option => option.text === stream.getVideoTracks()[0].label);
            videoElement.srcObject = stream;
        } catch (error) {
           // console.log(error);
        }
    }

    handleError(error) {
    }

    captureImage() {
        var videoElement = document.getElementById('videoCam')
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        canvas.width = document.getElementsByClassName("camara-webcam-dim")[0].offsetWidth;
        canvas.height = document.getElementsByClassName("camara-webcam-dim")[0].offsetHeight; 
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        let image = canvas.toDataURL('image/jpeg');
        this.setState({ 
            imgSrc: image,
            showImg: true 
         })
    }

    Volver() {
        this.setState({ showImg: false });
        this.setState({ setshowerr: false });
    }

    Guardar() {
        this.disabledbuttonf();
        var solicitud = {
            foto: this.state.imgSrc,
            identificacion: this.state.numidentifica,
             tokencapt: ""
        }
        if (this.state.isFace) {  
            axios.post(`${process.env.REACT_APP_API}api/Solicitud/imagen/rostro`, solicitud, {
            headers: {
                Authorization: `Bearer ${this.state.token_nueva_cuenta}`
            }
            }).then(res => {
                if (res.status == 200) {
                    this.setState({ showImg: false })
                    this.props.imgRostro(this.state.imgSrc);
                }
                this.activebuttonf();
            }).catch(error => {
                this.setState({ showImg: false })
                this.setState({ showerr: true })
                if (error.response && error.response.status === 401) {
                    this.setState({ showerrtoken: true })
                }                
                this.activebuttonf();
            });
        } else {
            axios.post(`${process.env.REACT_APP_API}api/Solicitud/imagen/cedula`, solicitud, {
            headers: {
                Authorization: `Bearer ${this.state.token_nueva_cuenta}`
            }
            }).then(res => {
                if (res.status == 200) {
                    this.setState({ showImg: false })
                    this.props.imgRostro(this.state.imgSrc);
                }
                this.activebuttonf();
            }).catch(error => {
                this.setState({ showImg: false })
                this.setState({ showerr: true })
                this.activebuttonf();
            });
        } 
    }

    render() {
        return (
            this.state.showImg && !this.state.showerr ?
                <div>
                    <div className='mt-4 camara-webcam'>
                        <h4 className='text-center'><strong>Foto Tomada</strong></h4>
                        <br/>
                        <div className="col-10">
                            <NotificacionTip mensaje="¿Está de acuerdo con la fotografía tomada?" />
                        </div>
                        <br/>
                        <div align="center "><img className="camara-img-dim mb-2" src={this.state.imgSrc} /></div>
                        <div className='camara-container-btnModal'>
                            <div className="row-opciones-camara ">
                                <div className="col-10">
                                    <button onClick={this.Volver} className='camara-btnModal-img'>Volver</button>
                                </div>
                                <div className="col-10">
                                    <button onClick={this.Guardar} className='camara-btnModal-img'>Guardar</button>
                                </div>
                              
                                {!this.state.activebutton ?
                                    <div  className="text-center col-12 col-sm-2">
                                        <span className="spinner-border spinner-border text-primary ms-1" role="status" aria-hidden="true"></span>
                                    </div>
                                : null}                              
                            </div>
                        </div>
                    </div>
                </div>
                : !this.state.showImg && !this.state.showerr ?
                    <div >
                        <div className=' camara-webcam'>
                            {this.state.isFace ? 
                                <h4 className='text-center'><strong>Foto del Rostro</strong></h4>
                                :
                                <h4 className='text-center'><strong>Foto de la Identificación</strong></h4>
                            }
                            <br/>
                            <div className="col-10">
                                <NotificacionTip mensaje="Procure tomar la fotografía en un lugar iluminado" />
                            </div>
                            <br/>
                            <div className=" text-center mb-3 col-10">
                                <select className="form-select" id="videoSource" onChange={() => this.getStream()}></select>
                            </div>

                            <video
                                id="videoCam"
                                autoPlay
                                muted
                                playsInline
                                className="camara-webcam-dim col-10"
                            >
                            </video>

                            <div className='camara-container-btnModal col-10'>
                                <button onClick={this.captureImage} className='camara-btnModal'>Tomar Foto</button>
                            </div>
                        </div>
                    </div>
                    :   
                    (this.state.showerrtoken ? 
                        <div>
                            <p className='text-center'><strong>Error en la Solicitud</strong></p>
                            <div className='mt-2 mb-3' align="center">
                                <img className="camara-equis" src={equis} alt="Error"></img>
                            </div>
                            <p className='camara-padd text-center'> El token del usuario ha expirado. Por favor comience el proceso nuevamente.</p>
                        </div>
                        :
                        !this.state.showImg && this.state.showerr ?
                        <div>
                            <p className='text-center'><strong>Error en la Solicitud</strong></p>
                            <div className='mt-2 mb-3' align="center">
                                <img className="camara-equis" src={equis} alt="Error"></img>
                            </div>
                            <p className='camara-padd text-center'> La fotografia tomada no es aceptable, procure tomar la foto en un lugar iluminado.</p>
                        </div> : null
                    )
        )
    }

}
export default camara;
